import { render } from "./DemoCrudChar2View.vue?vue&type=template&id=c6d4fd78&scoped=true"
import script from "./DemoCrudChar2View.vue?vue&type=script&lang=js"
export * from "./DemoCrudChar2View.vue?vue&type=script&lang=js"

import "./DemoCrudChar2View.vue?vue&type=style&index=0&id=c6d4fd78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6d4fd78"]])

export default __exports__